/*==================================================
ローディング
==================================================*/
$(document).ready(function() { 
  $(".animsition").animsition({
    inClass               :   'fade-in',
    outClass              :   'fade-out',
    inDuration            :    1500,
    outDuration           :    300,
    linkElement           :   '.animsition-link',
    loading               :    true,
    loadingParentElement  :   'body',
    loadingClass          :   'animsition-loading',
    unSupportCss          : [ 'animation-duration',
                              '-webkit-animation-duration',
                              '-o-animation-duration'
                            ],
    overlay               :   false,
    overlayClass          :   'animsition-overlay-slide',
    overlayParentElement  :   'body'
  });
});
/*==================================================
アニメーション
==================================================*/
$(window).on('load', function () {
$(function () {
setTimeout(function () {
  $(".mv-sec .mv-dog-box").addClass('active');
}, 400);
setTimeout(function () {
  $(".mv-sec .mv-item-box").addClass('active');
}, 800);
setTimeout(function () {
  $(".mv-sec .mv-point").addClass('active');
}, 1200);
});
});
$('.anime02').on('inview', function (event, isInView) {
  if (isInView) {
    const $this = $(this);
    setTimeout(function () {
      $this.addClass('active');
    }, 100);
  }
});
$('.anime03').on('inview', function (event, isInView) {
  if (isInView) {
    const $this = $(this);
    setTimeout(function () {
      $this.addClass('active');
    }, 500);
  }
});
/*==================================================
ナビ
==================================================*/
$(function () {
  $(document).ready(function () {
    var mySlidebars = new $.slidebars();
  });
});
/*==================================================
アコーディオン
==================================================*/
$(function () {
  $(".ac-menu .open").on("click", function () {
    const $clickedHeader = $(this);
    const $targetContent = $clickedHeader.next();

    // すでに開いている場合は閉じるだけ
    if ($targetContent.is(":visible")) {
      $targetContent.slideUp();
      $clickedHeader.removeClass("active");
    } else {
      // 他を閉じる
      $(".ac-menu .open").not($clickedHeader).removeClass("active");
      $(".ac-menu .open").not($clickedHeader).next().slideUp();

      // 自分を開く
      $targetContent.slideDown();
      $clickedHeader.addClass("active");
    }
  });
});

/*==================================================
クローンナビ
==================================================*/
$(function () {
  const $original = $('.animsition').first();
  const $cloned = $original.clone().removeClass('animsition').addClass('cloned');

  $('.header-clone-wrapper').empty().append($cloned);

  $(window).on('scroll', function () {
    const scrollTop = $(window).scrollTop();
    const windowWidth = $(window).width();
    const triggerPoint = windowWidth >= 768 ? 400 : 200;

    if (scrollTop > triggerPoint) {
      $('.header-clone-wrapper').fadeIn();
    } else {
      $('.header-clone-wrapper').fadeOut();
    }
  });
});
